buyBonusButton = {};

buyBonusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button._potBonusActive = false;

  button._flags.credit = {
    balance: 0,
  };

  button.idleMovieInfo = {};

  button.origEnableButton = button.enableButton;
  button.origDisableButton = button.disableButton;
  button.enableButton = () => {
    if (button.canEnable() === true && button.button.isButtonEnabled === false) {
      // button is becoming enabled
      // show button anims container
      button.showButtonAnimContainer();
    }
    button.origEnableButton();
  };
  button.disableButton = () => {
    if (button.button.isButtonEnabled === true) {
      // button is becoming disabled
      // hide button anims container
      button.hideButtonAnimContainer();
    }
    button.origDisableButton();
  };

  button.showButtonAnimContainer = function () {
    if (button.buttonAnimsContainer) {
      button.buttonAnimsContainer.visible = true;
      // button.skipFirstIdleAnim = true;
    }
  };

  button.hideButtonAnimContainer = function () {
    if (button.buttonAnimsContainer) {
      button.buttonAnimsContainer.visible = false;
    }
    button.stopIdleAnim();
  };

  button.playAnimAsync = async function (anim, movieInfo) {
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    anim.visible = true;
    anim.onComplete = () => {
      resolver();
    };
    anim.gotoAndPlay(0);

    if (movieInfo) {
      movieInfo.anim = anim;
      movieInfo.promise = promise;
      movieInfo.resolver = resolver;
      movieInfo.stoppedPrem = false;
    }

    await promise;

    anim.visible = false;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    var canEnable =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !button._sideMenuOpen &&
      button.hasValidStakes() &&
      !button.isPromotion;

    resourceManager.get(this.name + ':button').alpha = canEnable ? 1 : 0.5;

    return canEnable;
  };

  button.hasValidStakes = function () {
    let validStakes = false;
    if (checkForUndefined(this.gameConfig) !== true) {
      const buyBonusDataSuperFreeSpins = this.gameConfig.data.slotConfig.gameModes.BONUS_BUY_SUPER;
      const buyBonusDataFreeSpins = this.gameConfig.data.slotConfig.gameModes.BONUS_BUY_NORMAL;

      if (
        (buyBonusDataSuperFreeSpins !== undefined && buyBonusDataSuperFreeSpins.coinSizes.length !== 0) ||
        (buyBonusDataFreeSpins !== undefined && buyBonusDataFreeSpins.coinSizes.length !== 0)
      ) {
        validStakes = true;
      }
    }

    return validStakes;
  };

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    return (
      gdk.getPlatformAllowsBuyBonus() &&
      button.hasValidStakes() &&
      gdk.getRegulatedMarket() !== 'UK' &&
      !button._potBonusActive
    );
  };

  button.onPressedCallback = function () {
    // disable lucky bet button
    button.hideButtonAnimContainer();
    buyBonusPopup.show(function () {});
    resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton').enterBuyABonus();

    if (button.soundName !== '') button.playSound();
  };

  button.onGameConfig = function (event) {
    this.gameConfig = event;

    button.idleAnim = resourceManager.get('buttonContainer:buttonBar:buyBonusButton:buttonAnimsContainer:buttonIdle');
    button.idleAnim.gotoAndStop(0);
    button.idleAnim.visible = false;

    button.buttonAnimsContainer = resourceManager.get('buttonContainer:buttonBar:buyBonusButton:buttonAnimsContainer');
    button.buttonAnimsContainer.visible = false;
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.onStakeChanged = function (stake) {
    this._flags.stake = stake;
  };

  button.promotionStarted = function () {
    button.isPromotion = true;
  };

  button.promotionEnded = function () {
    button.isPromotion = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  button.onPotBonusStartEvent = function () {
    button._potBonusActive = true;
  };

  button.onPotBonusStartEventDead = function () {
    button._potBonusActive = false;
  };

  button.playIdleAnim = async function () {
    this.button.renderable = false;
    await button.playAnimAsync(button.idleAnim, button.idleMovieInfo);
    this.button.renderable = true;
  };

  button.stopIdleAnim = async function () {
    if (button.idleAnim.playing === true) {
      button.idleAnim.gotoAndStop(0);
      button.idleAnim.visible = false;

      if (button.idleMovieInfo) {
        button.idleMovieInfo.resolver(); // exit any awaits
        await button.idleMovieInfo.promise;
      }
    }

    // button.pauseIdleAnimTimeline();
  };

  button.onButtonIdleTimerExpired = function () {
    if (button.canEnable() && button._flags.showLuckyBetActive !== true && button.button.isButtonEnabled) {
      if (button.skipFirstIdleAnim === true) {
        button.skipFirstIdleAnim = false;
      } else {
        button.playIdleAnim();
      }
    }
  };

  messageBus.subscribe('buttonIdleTimerExpired', button.onButtonIdleTimerExpired.bind(button));
  messageBus.subscribe('game:sideMenuOpen', button.sideMenuOpenMsg.bind(button));
  messageBus.subscribe('game:sideMenuClosed', button.sideMenuClosedMsg.bind(button));
  messageBus.subscribe('common:BalanceEvent', button.onCreditChanged.bind(button));
  messageBus.subscribe('spinner:GameConfigEvent', button.onGameConfig.bind(button));
  messageBus.subscribe('stake:stakeChanged', button.onStakeChanged.bind(button));
  messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
  messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));

  return button;
};

buyBonusButton.initialise = function (json, object) {
  object.soundName = json.soundName || '';
};

buyBonusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'buyBonusButton',
  buyBonusButton.create,
  buyBonusButton.initialise,
  buyBonusButton.getFilesRequired
);
